var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    transform: "translate(0.496094 0.892578)",
    fill: "#FF6D59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4961 66.4561V48.9509L24.7047 47.4027C25.3385 47.0967 25.6557 46.4941 25.6557 45.8927C25.6557 45.2914 25.3385 44.6881 24.7047 44.3828L21.4961 42.8339V25.3287C21.4961 24.1307 22.7543 23.345 23.8374 23.8677L69.4973 45.8927L23.8374 67.9171C22.7543 68.4391 21.4961 67.6541 21.4961 66.4561Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4961 49.2609V48.9516L24.7047 47.4034C25.3385 47.0974 25.6557 46.4948 25.6557 45.8935C25.6557 45.2921 25.3385 44.6888 24.7047 44.3836L21.4961 42.8346V42.5254L69.4973 45.8935L21.4961 49.2609Z",
    fill: "#FF6D59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3c5827cf8eb691534b263e455e32785b.svg";
export { ForwardRef as ReactComponent };